// Generated by ReScript, PLEASE EDIT WITH CARE

import * as LumiReact from "lumi-rescript/lib/es6/src/LumiReact.bs.mjs";
import * as FontAwesome from "lumi-rescript/lib/es6/src/FontAwesome.bs.mjs";
import * as LumiRequest from "lumi-rescript/lib/es6/src/LumiRequest.bs.mjs";
import * as Belt_MapString from "rescript/lib/es6/belt_MapString.js";
import * as LumiReactReducer from "lumi-rescript/lib/es6/src/LumiReactReducer.bs.mjs";
import * as JsxRuntime from "react/jsx-runtime";
import * as API$LumiFacilityInfo from "lumi-facility-info/lib/es6/src/API.bs.mjs";
import * as Assets$GreenMobility from "./Assets.bs.mjs";
import * as Localization$LumiI18n from "lumi-i18n/lib/es6/src/Localization.bs.mjs";
import * as Constants$GreenMobility from "./Constants.bs.mjs";
import * as GreenMobility$LumiCentral from "lumi-central/lib/es6/src/GreenMobility.bs.mjs";
import * as Translation$LumiFacilityInfo from "lumi-facility-info/lib/es6/src/Translation.bs.mjs";
import * as CarFacilityList$GreenMobility from "./CarFacilityList.bs.mjs";
import * as BikeFacilityList$LumiFacilityInfo from "lumi-facility-info/lib/es6/src/BikeFacilityList.bs.mjs";

function App$Tabs(props) {
  var dispatch = props.dispatch;
  var activeTab = props.activeTab;
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("ul", {
                    children: [
                      JsxRuntime.jsx("li", {
                            children: JsxRuntime.jsxs("a", {
                                  children: [
                                    JsxRuntime.jsx("span", {
                                          children: JsxRuntime.jsx(FontAwesome.Solid.make, {
                                                name: "bicycle"
                                              }),
                                          className: "icon is-small"
                                        }),
                                    JsxRuntime.jsx("span", {
                                          children: JsxRuntime.jsx(Translation$LumiFacilityInfo.Provider.$$Text.make, {
                                                entry: "Bike"
                                              })
                                        })
                                  ],
                                  onClick: (function (param) {
                                      dispatch({
                                            TAG: "SetTab",
                                            _0: "Bike"
                                          });
                                    })
                                }),
                            className: LumiReact.classList([
                                  [
                                    "bike-tab",
                                    true
                                  ],
                                  [
                                    "is-active",
                                    activeTab === "Bike"
                                  ]
                                ])
                          }),
                      JsxRuntime.jsx("li", {
                            children: JsxRuntime.jsxs("a", {
                                  children: [
                                    JsxRuntime.jsx("span", {
                                          children: JsxRuntime.jsx(FontAwesome.Solid.make, {
                                                name: "car"
                                              }),
                                          className: "icon is-small"
                                        }),
                                    JsxRuntime.jsx("span", {
                                          children: JsxRuntime.jsx(Translation$LumiFacilityInfo.Provider.$$Text.make, {
                                                entry: "Car"
                                              })
                                        })
                                  ],
                                  onClick: (function (param) {
                                      dispatch({
                                            TAG: "SetTab",
                                            _0: "Car"
                                          });
                                    })
                                }),
                            className: LumiReact.classList([
                                  [
                                    "car-tab",
                                    true
                                  ],
                                  [
                                    "is-active",
                                    activeTab === "Car"
                                  ]
                                ])
                          })
                    ]
                  }),
              className: "tabs is-toggle is-fullwidth"
            });
}

var Tabs = {
  make: App$Tabs
};

function loadCarStaticData(dispatch) {
  return LumiReact.effects(Constants$GreenMobility.carParkUUIDs.map(function (identifier) {
                  return LumiRequest.resultFutureEffect(GreenMobility$LumiCentral.API.getStaticSPDP(identifier), (function (data) {
                                dispatch({
                                      TAG: "CarStaticDataReceived",
                                      _0: identifier,
                                      _1: data
                                    });
                              }), (function (prim) {
                                console.error(prim);
                              }));
                }));
}

function loadCarDynamicData(dispatch) {
  return LumiReact.effects(Constants$GreenMobility.carParkUUIDs.map(function (identifier) {
                  return LumiRequest.resultFutureEffect(GreenMobility$LumiCentral.API.getDynamicSPDP(identifier), (function (data) {
                                dispatch({
                                      TAG: "CarDynamicDataReceived",
                                      _0: identifier,
                                      _1: data
                                    });
                              }), (function (prim) {
                                console.error(prim);
                              }));
                }));
}

function loadAllData(dispatch) {
  return LumiReact.effects([
              loadCarStaticData(dispatch),
              loadCarDynamicData(dispatch)
            ]);
}

function App(props) {
  var match = LumiReactReducer.useReducer((function () {
          return {
                  TAG: "InitWithEffect",
                  _0: {
                    activeTab: "Bike",
                    carFacilityStaticData: undefined,
                    carFacilityDynamicData: undefined
                  },
                  _1: (function (param) {
                      return loadAllData(param.dispatch);
                    })
                };
        }), undefined, (function (state, action) {
          switch (action.TAG) {
            case "SetTab" :
                return {
                        TAG: "Update",
                        _0: {
                          activeTab: action._0,
                          carFacilityStaticData: state.carFacilityStaticData,
                          carFacilityDynamicData: state.carFacilityDynamicData
                        }
                      };
            case "CarStaticDataReceived" :
                var identifier = action._0;
                return {
                        TAG: "Update",
                        _0: {
                          activeTab: state.activeTab,
                          carFacilityStaticData: Belt_MapString.set(state.carFacilityStaticData, identifier, Constants$GreenMobility.overrideStaticCarData(identifier, action._1)),
                          carFacilityDynamicData: state.carFacilityDynamicData
                        }
                      };
            case "CarDynamicDataReceived" :
                return {
                        TAG: "Update",
                        _0: {
                          activeTab: state.activeTab,
                          carFacilityStaticData: state.carFacilityStaticData,
                          carFacilityDynamicData: Belt_MapString.set(state.carFacilityDynamicData, action._0, action._1)
                        }
                      };
            
          }
        }));
  var dispatch = match[1];
  var match$1 = match[0];
  var activeTab = match$1.activeTab;
  var bikeFacilityData = API$LumiFacilityInfo.useZippedParkingCounts(Constants$GreenMobility.organisation, Constants$GreenMobility.upperSuffix, Constants$GreenMobility.lowerSuffix, undefined, undefined, undefined);
  LumiReact.usePeriodic(30000, 30000, (function (next) {
          next(true);
          return loadCarDynamicData(dispatch);
        }), []);
  return JsxRuntime.jsx(Localization$LumiI18n.FixedProvider.make, {
              locale: "NLD",
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(App$Tabs, {
                            activeTab: activeTab,
                            dispatch: dispatch
                          }),
                      activeTab === "Bike" ? LumiReact.renderOption(undefined, bikeFacilityData, (function (bikeFacilityData) {
                                var fullThreshold = function (param) {
                                  return Constants$GreenMobility.fullThreshold;
                                };
                                var website = function (param) {
                                  return Constants$GreenMobility.bikeWebsite;
                                };
                                return JsxRuntime.jsx(BikeFacilityList$LumiFacilityInfo.make, {
                                            bikeFacilityData: bikeFacilityData,
                                            fullThreshold: fullThreshold,
                                            website: website,
                                            displayAddress: Constants$GreenMobility.displayAddress,
                                            imgBikeUpper: Assets$GreenMobility.imgBikeUpper,
                                            imgBikeLower: Assets$GreenMobility.imgBikeLower
                                          });
                              })) : JsxRuntime.jsx(CarFacilityList$GreenMobility.make, {
                              carFacilityStaticData: match$1.carFacilityStaticData,
                              carFacilityDynamicData: match$1.carFacilityDynamicData
                            })
                    ],
                    className: "toplevel is-unselectable"
                  })
            });
}

var GM;

var T;

var make = App;

export {
  GM ,
  T ,
  Tabs ,
  loadCarStaticData ,
  loadCarDynamicData ,
  loadAllData ,
  make ,
}
/* LumiReact Not a pure module */
